export const environment = {
  production: false,
  apiUri: "https://canvasser-app-api-dev.plusmoreplatform.com",
  version: "0.0.6",
  recaptchaKey: "6Lc26hoqAAAAAFvAYlaId95rmWPeVUGDWhzfDtHt",
};
